<template>
  <div
    data-testid="checks-general-panel"
    class="tw-pb-4 tw-px-6 tw-flex tw-flex-col tw-gap-4"
  >
    <SfAssistantCheck
      v-for="check in generalChecks"
      :key="check.id"
      :check="check"
      :read="checkReadStatus[check.id]"
      :read-by-users="checkReadByUsers[check.id]"
    />
    <div
      class="
        tw-mx-auto
        tw-mb-4
        tw-font-medium
        tw-text-sm
        tw-text-sf-gray-light
        tw-text-center
      "
    >
      {{ I18n.t('assistant_check.page.checks.no_more') }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'
import SfAssistantCheck from '@app/application/sf-assistant-checks/components/sf-assistant-check.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useSfAssistantChecksPage } from '../stores/page'
import { useAssistantChecksStore } from '@app/application/sf-assistant-checks/stores/assistant-checks'

const pageStore = useSfAssistantChecksPage()
const assistantChecksStore = useAssistantChecksStore()
const { assistantChecks } = storeToRefs(assistantChecksStore)
const { checkReadStatus, checkReadByUsers, generalCheckIds } =
  storeToRefs(pageStore)
const I18n = useI18n()

onMounted(() => {
  assistantChecksStore.initFromPageStore()
})

const generalChecks = computed(() =>
  generalCheckIds.value
    .map((id) => assistantChecks.value[id])
    .filter((check): check is NonNullable<typeof check> => !!check)
)
</script>
